import Api from "@/services/Api";

export default {
  createDraftOrder(order) {
    return Api().post("draft-orders", order);
  },
  submitOrgInquiry(inquiry) {
    return Api().post("org-inquiry", inquiry);
  },
  submitDistInquiry(inquiry) {
    return Api().post("dist-inquiry", inquiry);
  },
  submitWedInquiry(inquiry) {
    return Api().post("wed-inquiry", inquiry);
  },
  submitIndInquiry(inquiry) {
    return Api().post("ind-inquiry", inquiry);
  },
  createCustomLineItem(item) {
    return Api().post("custom-line-items", item);
  },
  getProductById(params) {
    return Api().post("getProductData", params);
  },
  getAllProductsById(params) {
    return Api().post("getAllProductData", params);
  }
};



// WEBPACK FOOTER //
// ./src/services/ProjectsService.js